import { Pipe, PipeTransform } from '@angular/core';
import { Observable, map, of } from 'rxjs';
import { TranslateService } from 'src/app/core/translate';

@Pipe({
    name: 'trans'
})
export class GetKeyValueByLangPipe implements PipeTransform {
    public constructor(private translateService: TranslateService) {}

    transform(key: string): Observable<string> {
        console.log(key);
        if (key) {
            return this.translateService.currentLang$.pipe(
                // switchMap(lang => this.translateService.getTranslation(lang)),
                // map(translation => {
                //     console.log(key, translation[key], translation);
                //     return translation[key] || key;
                // })
                map(lang => 'x')
            );
        }
        return of(key);
    }
}
